module.exports = __webpack_public_path__ + "img/image15.ba9de3ed.png";